export default __webpack_public_path__ + "static/media/new9.2db152a5.png";